<template>
  <div>
    <div v-if="loading" class="text-center text-danger my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong class="ml-2">{{ $t('LIST_LOADING_LABEL', {catalog: $t('ORGANIZATIONS_LABEL')})  | capitalize}}</strong>
    </div>
    <b-select
        v-else
        id="organization-input" type="text"
        :state="state"
        :value="content"
        @change="handleInput" class="w-100">
      <b-select-option :key="item.id" v-for="item in items" :value="valueType === 'id' ? item.id : item._links.self.href">{{$t(item.name)}}</b-select-option>
    </b-select>
    <b-form-invalid-feedback id="organization-input-feedback">
      <div v-for="error in errors" :key="error.error">
        {{ $t('FORMS_ERROR_FIELD_' + error.error, {...error.params, ...{field: $t('ORGANIZATION_LABEL')},})  | capitalize }}
      </div>
    </b-form-invalid-feedback>
  </div>

</template>

<script>
import {VModel, SendsMessages} from "@/mixins";
import Organization from "@/organization/index";

export default {
  name: "OrganizationSingleSelector",
  props: ['state', 'errors', 'valueType'],
  mixins: [VModel, SendsMessages],
  async mounted() {
    try {
      this.loading = true;
      this.items = await Organization.findAll({size: 1000, filter: {status: true}});
    } catch(e) {
      this.sendError('ERROR_LOADING_CATALOG', {}, e);
    } finally {
      this.loading = false;
    }
  },
  data() {
    return {
      loading: false,
      items: []
    }
  }
}
</script>

<style scoped>

</style>
